class WCCartToggle extends HTMLElement {
  constructor() {
    super();

    const toggleSelectors = [
      'a',
      'button',
      '[data-cart-toggle]'
    ]
    this.toggleButton = this.querySelector(toggleSelectors.join(','))
  }

  connectedCallback() {
    this.toggleButton.addEventListener('click', this.toggleCart.bind(this))
  }

  disconnectedCallback() {
    this.toggleButton.removeEventListener('click', this.toggleCart.bind(this))
  }

  toggleCart(event) {
    event.preventDefault()
    const cartAction = this.dataset?.toggle?.toUpperCase() ?? null

    if (cartAction) {
      window.dispatchEvent(new CustomEvent('MINI_CART_ACTION', {
        detail: {
          action: cartAction,
          disableUpdate: true
        }
      }))
    }
  }
}

if (typeof customElements.get('wc-cart-toggle') === 'undefined') {
  customElements.define('wc-cart-toggle', WCCartToggle);
}